import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=5516c8d7"
import script from "./FeedbackCard.vue?vue&type=script&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=5516c8d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports